import { useQuery } from '@apollo/client'
import { gql } from '~/__generated__'

const GET_CURRENT_USER = gql(`
  query GetCurrentUser {
    me {
      email
      firstName
      lastName
      lastLoginAt
      createdAt
      updatedAt
      groups {
        name
        description
        permissions {
          name
          description
        }
      }
    }
  }
`)

export const useCurrentUser = () => {
  const { data, loading, error, refetch } = useQuery(GET_CURRENT_USER, {
    // Cache na 5 minut, ale pozwól na background refetch
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
    // Automatycznie refetch gdy użytkownik wróci do aplikacji
    notifyOnNetworkStatusChange: true,
  })

  // FlatMap all permissions from user's groups
  const userPermissions =
    data?.me?.groups
      ?.flatMap((group) => group.permissions || [])
      .filter(
        (permission, index, array) =>
          array.findIndex((p) => p.name === permission.name) === index
      ) || []

  return {
    user: data?.me,
    loading,
    error,
    refetch,
    // Helper functions
    isLoggedIn: !!data?.me,
    fullName: data?.me ? `${data.me.firstName} ${data.me.lastName}` : '',
    permissions: userPermissions,
  }
}
